module.exports = "/_next/static/images/buyers_6-fa83916caab6e248202562813d79749c.png";